import React from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useObjectContext } from '@/hooks/useObjectContext';

export const CreateTaskButton = () => {
	const dispatch = useDispatch();

	const { clientRow } = useObjectContext();

	const handleOpenDialog = () => {
		dispatch(openDialog({ dialogName: 'task', data: { client: clientRow } }));
	};

	return (
		<div style={{ display: 'flex', justifyContent: 'right', paddingBottom: '1em' }}>
			<Button variant='tab_header' startIcon={<Add />} onClick={handleOpenDialog}>
				Create task
			</Button>
		</div>
	);
};
